<template>
  <div>
    <table>
      <thead>
        <tr>
          <th class="product-header">Product</th>
          <th class="product-title">Product Title</th>
          <th class="product-size">Option</th>
          <th class="product-quantity">Quantity</th>
          <th class="product-subtotal" v-show="showPrices">Subtotal</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>
            <div class="flex items-center justify-center">
              <img :src="item.variantImage" />
            </div>
          </td>
          <td>{{ item.productName }}</td>
          <td>
            <span class="enter-line">{{ displaySelection(item) }}</span>
          </td>
          <td>{{ item.quantity }}</td>
          <td v-show="showPrices">{{ formatCurrency(item.amount) }}</td>
        </tr>
      </tbody>
      <tfoot v-show="showPrices">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td>Total</td>
          <td>{{ totalAmount }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import DateFns from '@/mixins/DateFns'
import Util from '@/mixins/Util'

export default {
  name: 'OrderItemGrid',
  mixins: [DateFns, Util],
  props: {
    items: Array
  },

  computed: {
    totalAmount() {
      let total = 0
      this.items.forEach(item => {
        total += parseFloat(item.price) * parseInt(item.quantity)
      })

      return this.formatCurrency(total)
    },

    showPrices() {
      return this.$store.getters['team/showPrices']
    }
  },

  methods: {
    showSizeIf(product) {
      if (product.size !== '-' && product.size !== undefined) {
        return true
      }

      return false
    },
    displaySelection(variant) {
      if (variant) {
        let selections = []
        if (variant.type) selections.push(variant.type)
        if (variant.color) selections.push(variant.color)
        if (variant.size) selections.push(variant.size)

        return selections.map(selection => selection).join('\n')
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

table {
  width: 100%;
  margin-top: 2rem;
  border-spacing: 0px;
  border-collapse: separate;

  & thead > tr > th {
    color: $main-6;
    font-size: 0.875rem;
    padding: 1rem;
    border-bottom: 1px solid $onyx;
  }

  & tbody > tr > td {
    color: $main-6;
    font-size: 0.813rem;
    padding: 0.25rem;
    border-bottom: 1px solid $onyx;
  }

  & tbody > tr > td:nth-child(2) {
    padding-left: 0.75rem;
    text-align: left;
  }

  & tfoot > tr > td {
    font-size: 0.813rem;
    padding-top: 3rem;
  }

  & tfoot > tr > td:nth-child(4) {
    font-weight: 600;
  }

  .product-header {
    width: 20%;
  }

  .product-title {
    width: 35%;
    text-align: left;
  }
}

img {
  width: 120px;
  height: 120px;
  max-width: 100%;
  object-fit: scale-down;
}

.flexbox-container {
  display: flex;

  .header {
    padding: 1.5rem 0;
  }

  .column-image {
    width: 16%;
  }

  .column-description {
    width: 30%;
  }

  .column-quantity {
    width: 15%;
  }

  .content {
    padding-bottom: 0.5rem;

    img {
      max-width: 60%;
    }

    .item-name {
      font-weight: bold;
      padding-bottom: 1rem;
      font-size: $content-font-size;
    }

    span {
      font-size: $body-base;
      opacity: 0.6;
    }
  }
}

.flexbox-container > div {
  width: 15%;
  text-align: left;
  padding: 0rem 0rem;
  margin-right: 20px;
}
</style>
